import React from 'react';
import HeroSection from '../components/HeroSection';
import ServiceCard from '../components/ServiceCard';
import CTABanner from '../components/CTABanner';
import './ServicesPage.css';

function ServicesPage() {
  return (
    <div className="services-page">
      <HeroSection
        backgroundImage="/images/hero_services.jpg"
        title="Our Commercial Cleaning Services"
        subtitle="Industry-approved methods that remove embedded dirt, stains, and odours — improving hygiene, extending carpet life, and making your space shine."
        ctaText="Discuss Your Requirements"
        ctaLink="/contact"
      />

      {/* What We Offer */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>What We Offer</h2>
            <p>
              Every commercial space is different. We tailor our approach to your
              environment, traffic patterns, and schedule.
            </p>
          </div>
          <div className="grid grid--3">
            <ServiceCard
              icon="&#128167;"
              title="Deep Cleaning"
              description="Thorough hot-water extraction that removes deep-seated dirt, allergens, and bacteria — restoring your carpets to their best."
            />
            <ServiceCard
              icon="&#10024;"
              title="Stain Removal"
              description="Specialist treatment for stubborn stains including coffee, ink, grease, and high-traffic discolouration."
            />
            <ServiceCard
              icon="&#128203;"
              title="Maintenance Plans"
              description="Scheduled cleaning programmes that protect your investment and keep your carpets consistently fresh year-round."
            />
          </div>
        </div>
      </section>

      {/* Equipment & Quality */}
      <section className="section section--soft">
        <div className="container">
          <div className="split">
            <div className="split__image">
              <img
                src="/images/professional_equipment_detail.jpg"
                alt="Professional-grade carpet cleaning extraction wand in action"
              />
            </div>
            <div className="split__content">
              <h2>Professional-Grade Equipment</h2>
              <p>
                We invest in the best tools in the industry. Our truck-mounted and portable 
                extraction systems deliver a deep clean that consumer-grade machines simply 
                cannot match.
              </p>
              <p>
                The result is faster drying times, deeper soil removal, and carpets that look 
                and feel noticeably better — after every single clean.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Specialist Services */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Explore Our Specialist Services</h2>
            <p>
              We offer dedicated cleaning solutions for the sectors we know best.
            </p>
          </div>
          <div className="grid grid--3">
            <ServiceCard
              icon="&#127976;"
              title="Hotel Cleaning"
              description="Discreet, overnight cleaning for guest rooms, lobbies, and function areas — scheduled around occupancy."
              linkTo="/hotels"
              linkLabel="Learn more"
            />
            <ServiceCard
              icon="&#127970;"
              title="Office Cleaning"
              description="After-hours deep cleaning that keeps workspaces hygienic, professional, and impressive."
              linkTo="/offices"
              linkLabel="Learn more"
            />
            <ServiceCard
              icon="&#127968;"
              title="Home Cleaning"
              description="Professional carpet cleaning for living rooms, bedrooms, stairs, and hallways in your home."
              linkTo="/domestic"
              linkLabel="Learn more"
            />
          </div>
        </div>
      </section>

      {/* Eco-friendly */}
      <section className="section section--muted">
        <div className="container">
          <div className="split split--reverse">
            <div className="split__image">
              <img
                src="/images/eco_friendly_cleaning.jpg"
                alt="Eco-friendly carpet cleaning products and professional technique"
              />
            </div>
            <div className="split__content">
              <h2>Safe, Eco-Friendly Products</h2>
              <p>
                We use environmentally responsible cleaning solutions that are tough on dirt 
                but gentle on people. Our products are non-toxic, low-residue, and safe for 
                use around staff, visitors, children, and pets.
              </p>
              <p>
                Effective cleaning doesn't have to come at the expense of the environment.
              </p>
            </div>
          </div>
        </div>
      </section>

      <CTABanner
        heading="Need a Tailored Cleaning Solution?"
        description="Tell us about your space and we'll put together a plan that fits your business perfectly."
        ctaText="Get a Free Quote"
      />
    </div>
  );
}

export default ServicesPage;
